<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-4 py-0">
          <v-row class="align-center">
            <v-col cols="'12" md="9">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-col cols="'12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :items-per-page="-1"
          hide-default-footer
          :mobile-breakpoint="breakpoint"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id_agent="{ item }">
            <v-btn @click="$copy(item.id_agent)" x-small>{{
              item.id_agent
            }}</v-btn>
          </template>

          <template v-slot:item.name_agent="{ item }">
            <a
              @click="
                $profile.showProfileDrawer(
                  item.id_agent,
                  'administrator/agents/getAgent'
                )
              "
            >
              <v-icon color="blue" x-small>mdi-account</v-icon>
              {{ item.name_agent }}
            </a>
          </template>

          <template v-slot:item.name_local="{ item }">
            <a
              class="green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_local,
                  'administrator/locals/getLocal'
                )
              "
            >
              <v-icon color="green" x-small>mdi-account-multiple</v-icon>
              {{ item.name_local }}
            </a>
          </template>

          <!-- VALUES -->
          <template
            v-for="(value, index) in valueColors"
            v-slot:[`item.${value}`]="{ item }"
          >
            <span class="caption" :key="index" :class="getColor(item[value])">{{
              item[value]
            }}</span>
          </template>

          <!-- Status -->
          <template v-slot:item.status="{ item }">
            <v-icon :color="handleColorStatus(item.status)" size="16">
              mdi-circle
            </v-icon>
          </template>

          <!-- ACTIONS -->
          <template v-slot:item.action="{ item }">
            <v-btn-toggle dense>
              <BalanceAgent
                :agent="{
                  agentId: item.id_agent,
                  agentName: item.name_agent,
                }"
              />

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      [
                        $router.push({
                          name: 'AdministratorFinancialBalanceInsertEntryDeal',
                          params: { id_agente: item.id_agent },
                          query: {
                            name_agent_extract: item.name_agent,
                            balance: item.balance,
                          },
                        }),
                        openExtractDialog(),
                      ]
                    "
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("launch") }}</span>
              </v-tooltip>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card>

      <!-- Resume -->
      <div class="mt-4" v-if="items.length != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">{{ $t("resumeSummary") }}</div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr
                      v-for="(item, index) in keysResume"
                      :key="`${index} ${Math.random()}`"
                    >
                      <td class="caption">{{ TranslateKey(item) }}</td>
                      <td class="text-right" :class="resume[item].classColor">
                        {{ resume[item].value }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>

    <!-- Route-View -->
    <router-view></router-view>
  </div>
</template>
<script>
import BalanceAgent from "./balanceAgent.vue";
import HeaderPrint from "@/components/common/header-print";
export default {
  components: { BalanceAgent, HeaderPrint },
  name: "administrator-financial-balance",

  data: () => ({
    items: [],
    breakpoint: "xs",
    search: "",
    resume: null,
    keysResume: [],
    agente: "",
    valueColors: [
      "previous_balance",
      "sales",
      "commission_sales",
      "cancellations",
      "prizes_paid",
      "balance",
    ],
  }),

  computed: {
    headers() {
      return [
        { text: "Id", value: "id_agent" },
        { text: this.$t("agent"), value: "name_agent" },
        { text: this.$t("mLocal"), value: "name_local" },
        { text: this.$t("previousBalance"), value: "previous_balance" },
        { text: this.$t("qty"), value: "count_sales" },
        { text: this.$t("sales"), value: "sales" },
        { text: this.$t("commission"), value: "commission_sales" },
        { text: this.$t("cancellations"), value: "cancellations" },
        { text: this.$t("awards"), value: "prizes_paid" },
        { text: this.$t("balanceReport"), value: "balance" },
        { text: this.$t("status"), value: "status" },
        {
          text: this.$t("actions"),
          value: "action",
          align: "center d-print-none",
          sortable: false,
        },
      ];
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    // id_agent() {
    //   return this.$store.state.filters.autocompleteAgents.id;
    // },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    // updateListBalance() {
    //   return this.$store.state.updateListBalance;
    // },
  },
  watch: {
    refresh(val) {
      val && this.requestApi();
      this.$store.commit("setRefresh", false);
    },
    saveFilters(val) {
      val && this.requestApi();
    },
    // updateListBalance(val) {
    //   this.items.filter((item) => {
    //     if (item.id_agent == val.id_agent) {
    //       item.balance = val.value;
    //       item.previous_balance = val.value;

    //       item.count_sales = "0.00";
    //       item.cancellations = "0.00";
    //       item.commission_sales = "0.00";
    //       item.deals = "0.00";
    //       item.prizes_paid = "0.00";
    //       item.sales = "0.00";
    //     }
    //   });
    // },
  },
  methods: {
    resetPage() {
      this.search = "";
    },

    async requestApi() {
      this.resetPage();

      const body = {
        id_regional: this.id_regional,
        id_local: this.id_local,
        // id_user: this.id_agent,
      };

      const response = await this.$request.post(
        "/administrator/financial/listBalance",
        body
      );
      this.items = response.length == 0 ? [] : response.dados;
      this.buildResume(this.items);
    },

    buildResume(data) {
      if (!data) return;

      // SOMANDO
      const sum = (key) => {
        return data
          .map((item) => Number(item[key]))
          .reduce((a, b) => a + b, 0)
          .toFixed(2);
      };

      // CHAVES QUE DEVEM SER SOMADAS
      let resume = {
        previous_balance: {},
        sales: {},
        commission_sales: {},
        cancellations: {},
        prizes_paid: {},
        balance: {},
      };

      // CONSTRUINDO O OBJETO DE RESUMO
      Object.keys(resume).forEach((key) => {
        const total = sum(key);
        resume[key].value = `${total}`;
        resume[key].classColor = this.getColor(total);
      });

      const complement = {
        count_sales: { value: Number(sum("count_sales")) },
      };

      // ARMAZENANDO PARA EXIBIR NA UI
      this.resume = { ...complement, ...resume };
      this.keysResume = Object.keys(this.resume);
    },

    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
    // handle color status
    handleColorStatus(status) {
      // if (status == 0) return "red";
      if (status == 0) return "orange";
      if (status == 1) return "green";
    },

    openExtractDialog() {
      // Open Dialog - Vuex
      this.$store.commit("showDialog", true);
    },
    TranslateKey: function(key) {
      const myKeysTranslated = {
        previous_balance: this.$t("previousBalance"),
        sales: this.$t("sales"),
        commission_sales: this.$t("commission"),
        cancellations: this.$t("cancellations"),
        prizes_paid: this.$t("awards"),
        // deals: "Acertos",
        count_sales: this.$t("qtySales"),
        balance: this.$t("totalBalance"),
      };

      return myKeysTranslated[key] || null;
    },
  },
};
</script>
